import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { updateUser } from '../../../slices/UserManagement/UpdateUser/thunk';
import { activateUser } from '../../../slices/UserManagement/Activate/thunk';
import { deactivateUser } from '../../../slices/UserManagement/Deactivate/thunk';

export const handleModalAction = ({ 
    values, 
    status, 
    setLoading, 
    navigate, 
    userId, 
    dispatch, 
    toggleModal,
    operatorId,
    onCancel 
}) => {
    const phoneNumber = values.phone ? formatPhoneNumberIntl(values.phone) : '';
    const dialCodeWithPlus = phoneNumber.match(/^\+\d+(\s|$)/)?.[0];
    const restOfNumber = phoneNumber.slice(dialCodeWithPlus?.length);
    const mobileNumberWithoutSpaces = restOfNumber.replace(/\s/g, '');
    const dialCodeWithoutSpaces = dialCodeWithPlus.replace(/\s/g, '');
    const isView = location.pathname.includes("view-operator") ? location : false
    const formattedValues = {
        userName: values?.username,
        role: values?.userrole?.value,
        email: values?.email,
        profile: {
            firstName: values?.firstname,
            lastName: values?.lastname,
        },
        phone: mobileNumberWithoutSpaces,
        dialCode: dialCodeWithoutSpaces,
        status: status.toLowerCase(),
    };

    status === 'active' || status ==='Active'? dispatch(activateUser(userId, setLoading, location,operatorId)):dispatch(deactivateUser(userId, setLoading, location,operatorId))
    dispatch(updateUser(setLoading, formattedValues, navigate, userId, false,isView));
    if(isView){
        onCancel();
    }
    toggleModal();
};
